export const INNER_PATHS = [
  { url: 'questions', name: 'game.question.title' },
  { url: 'suggestions', name: 'game.question.title' },
]
